import React, { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useLocation
} from 'react-router-dom';

import { UserContextProvider } from '../context/authContext';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from './Components/signin_signup/LoginPage';
import { App } from '../App';
import { DocumentContextProvider } from '../context/documentContext';
import { ProjectContextProvider } from '../context/projectContext';
import { SignupPage } from './Components/signin_signup/SignupPage';
import { AppContextProvider } from '../context/appContext';
import { AlertProvider } from '../context/alertContext';
import { NotificationProvider } from '../context/notificationContext';
import { SearchHistoryProvider } from '../context/searchHistoryContext';
import SignupPageStart from './Components/signin_signup/1Signup';
import LoginPageNew from './Components/signin_signup/LoginPageNew';
import { CreateAccount } from './Components/accountViews/CreateAccount';
import CreateAccountNew from './Components/accountViews/CreateAccountNew';
import SignupComplete from './Components/accountViews/signupComplete';
import ResetPassword from './Components/signin_signup/resetPassword';
import { recordRumPageView } from '../hooks/rum';

// Wraps children with all your providers
function withProviders(children: React.ReactNode) {
  return (
    <UserContextProvider>
      <AlertProvider>
        <SearchHistoryProvider>
          <AppContextProvider>
            <ProjectContextProvider>
              <DocumentContextProvider>
                <NotificationProvider>{children}</NotificationProvider>
              </DocumentContextProvider>
            </ProjectContextProvider>
          </AppContextProvider>
        </SearchHistoryProvider>
      </AlertProvider>
    </UserContextProvider>
  );
}

const PageViewTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    try {
      recordRumPageView({
        pageId: location.pathname + location.search,
        pageAttributes: { template: 'app-shell' }
      });
    } catch (e) {
      // no-op
    }
  }, [location.pathname, location.search]);
  return null;
};

const router = createBrowserRouter([
  {
    path: '/login',
    element: withProviders(
      <>
        <PageViewTracker />
        <LoginPageNew />
      </>
    )
  },
  {
    path: '/signup',
    element: withProviders(
      <>
        <PageViewTracker />
        <SignupPageStart />
      </>
    )
  },
  {
    path: '/reset-password',
    element: withProviders(
      <>
        <PageViewTracker />
        <ResetPassword />
      </>
    )
  },
  {
    element: withProviders(
      <>
        <PageViewTracker />
        <ProtectedRoute />
      </>
    ),
    children: [
      {
        path: '/account-new',
        element: <CreateAccountNew />
      },
      {
        path: '/confirmation',
        element: <SignupComplete />
      },
      {
        path: '/app/*',
        element: <App />
      },
      {
        path: '*',
        element: <Navigate to="/app/landing" replace />
      }
    ]
  }
]);

export const Routing = () => {
  return (
    <RouterProvider router={router} fallbackElement={<div>Loading...</div>} />
  );
};
